import React from 'react';
import {Col, Form, Modal, Row, Switch} from "antd";
import {t} from "i18next";
import {updateAttendance} from "../../../../../api/setting/timekeeping";

const StatusLocation = props => {
    const handleChange = (value) => {
      if(value && !props.defaultConfigGps){

          return  Modal.confirm({
              title: t("tnp.setting.disableGps"),
              content:
                  <p  dangerouslySetInnerHTML={{
                      __html:  t("tnp.setting.enableGps",{name : `<span class="font-bold">${props.title}</span>` })
                  }} />,
              icon: null,
              width: 500,
              onOk: () => {
                  return updateAttendance(true).then(response => {

                  })
              },
              onCancel : () => {
                    props.form.setFieldValue("status" ,false)
              },

              autoFocusButton: null,
              closable: true,
              maskClosable: false,
              okText: t("common.agree"),
              cancelText: t("tnp.button.cancelText")
          })
      }
    }
    return (
        props.defaultChecked !== undefined &&  <Row gutter={12} className={"mt-2"}>
            <Col
                xxl={{span: 16}}
                xl={{span: 16}}
                lg={{span: 16}}>
                <Form.Item
                    initialValue={props.defaultChecked}
                    valuePropName="checked"
                    label={<b>{props.label}</b>}
                    name={props.name}>
                    <Switch checkedChildren={t("tnp.setting.enable")} unCheckedChildren={t("tnp.setting.disable")} onChange={(v) =>
                        handleChange(v)} defaultChecked={props.defaultChecked}  />
                </Form.Item>
            </Col>
        </Row>
    );
};



export default StatusLocation;
